export default {
  title: {
    add: 'Script toevoegen',
    update: 'Script bijwerken',
  },
  form: {
    strategy: {
      label: 'Strategie',
      placeholder: 'Selecteer strategie',
    },
    source: {
      label: 'Bron (src)',
      placeholder: 'Voer bron in',
    },
    async: {
      label: 'Async',
      placeholder: 'Selecteer async',
    },
    content: {
      label: 'Inhoud',
      placeholder: 'Voer inhoud in',
    },
  },
  alert: {
    use_case: 'Gebruiksscenario',
  },
  buttons: {
    save: 'Opslaan',
  },
};
